export default __webpack_public_path__ + "static/media/User1.29a0a608.svg";